<template>
  <div class="release-notes">
    <h6 class="pt-1">INTERFACE</h6>
    <p>An app-level user friendly seamless experience on PC, laptop , Windows or Mac or anywhere where web browser is installed.</p>

    <h6>SESSION</h6>
    <p>ZWING POS will keep track record all the transactions and cash in/cash out made by the different cashiers in the store using our session management.</p>

    <h6>SALESPERSON</h6>
    <ul>
      <li>View all the available salespersons in the store (They will be added from the backend vendor panel).</li>
      <li>Assign a salesperson to an individual product or to all the products added in the cart.</li>
    </ul>

    <h6>HOLD BILL</h6>
    <p>Bill can be held for further processing and list of hold bill’s can be viewed in ‘View Held Bills’ section.</p>

    <h6>DISCOUNT</h6>
    <ul>
      <li>Manual discount - It can be added in two different ways, by exact discount amount or via percentage.</li>
      <li>Voucher discount - Customer will receive a voucher while returning items on their registered mobile number and can avail at the time of checkout.</li>
      <li>Phone discount - Customer can redeem the voucher by sharing his OTP to cashier at the time of the billing.</li>
    </ul>

    <h6>CARRY BAGS</h6>
    <p>A list of available carry bags will be listed and functionality to add them in the cart.</p>

    <h6>PRODUCT CATALOGUE</h6>
    <ul>
      <li>Item catalogue will be accessible through ‘View Catalogue’ button.</li>
      <li>Any particular product can be searched via entering his designated barcode or by its name in the ‘Enter barcode & Search product’ search field.</li>
      <li>At the time of initial loading of the application, full catalogue will be downloaded in the application so it will be easier to access for further activities. The catalogue can be reloaded/refreshed via ‘refreshed catalogue’ button.</li>
    </ul>

    <h6>CHECKOUT</h6>
    <ul>
      <li>Search product by barcode or product name.</li>
      <li>Scan barcode to add product in the cart.</li>
      <li>Barcode reader can easily be connected with USB port.</li>
      <li>Feature to connect weighing machine through web browser.</li>
      <li>Loose quantity weight products can be measured and easily update in the cart.</li>
      <li>Add bill level remark for further records and references.</li>
      <li>Email or SMS customer invoice to his registered number and email address.</li>
      <li>Print invoice to any thermal POS printer.</li>
    </ul>

    <h6>CUSTOMER MANAGEMENT</h6>
    <ul>
      <li>Manage central customer information and ability to tag/untag customer on processing the billing.</li>
      <li>Use the default customer or guest checkout.</li>
    </ul>

    <h6>INVOICE MANAGEMENT</h6>
    <ul>
      <li>Invoice list of all the processed orders in POS.</li>
      <li>Filter invoice data as per date, status and mode of payment.</li>
    </ul>

    <h6>TAX</h6>
    <p>ZWING POS include the sales tax automatically on each item as well as on total items in the cart.</p>

    <h6>PAYMENT</h6>
    <ul>
      <li>Pay an order with multiple payment methods(cash, credit card, Paytm and GooglePay or Store credit).</li>
      <li>Enable to make payment in Split and Lay-By mode.</li>
    </ul>

    <h6>REFUND</h6>
    <ul>
      <li>Refund orders from POS Screen with optional authentication key for cashier.</li>
      <li>Instantly receive notification for return items as a voucher code in customer registered mobile number.</li>
      <li>Ability to Reprint the invoice.</li>
    </ul>

    <h6>GOODS RETURN NOTE (GRN)</h6>
    <ul>
      <li>Check stock availability of current store.</li>
      <li>Feature of Generating GRN from advice list & ad-hoc.</li>
      <li>Track every in-out of stock from inventory and record them as received, damaged & lost while creating a GRN.</li>
      <li>Filter GRN on the basis of Date and Status Supplier name.</li>
      <li>Print GRN Report to your POS thermal printer.</li>
    </ul>

    <h6>SETTINGS</h6>
    <ul>
      <li>Update your personal information.</li>
      <li>Change theme to light and dark mode as per your convenience.</li>
      <li>Set as default your POS thermal printer.</li>
      <li>Manage your license information and its existing status.</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "release-notes"
};
</script>

<style lang="scss" scoped>
.theme-dark {
  .release-notes {
    color: #808080;
    h6 {
      color: #cac4c4 !important;
    }
    p {
      color: #808080 !important;
      font-size: 0.8125rem !important;
    }
  }
}
.release-notes {
  overflow-y: auto;
  height: 80vh;
  h6 {
    font-size: 15px !important;
  }
  ul {
    padding: 0px 0px 0px 30px;
  }
  @include custom-scrollbar();
}
</style>